if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    function getAccessibility() {
        if(document.querySelector('.brand_slides')) {
            let brand_slider = document.querySelector('.brand_slides');
            let brand_child = brand_slider.querySelectorAll('.brand_item');

            let counter = 0;
            brand_child.forEach( (brand) => {
                if(brand.querySelector('a')) {
                    counter++
                } else {
                    counter--
                }
            })

            if( counter > 0) {
                return false;
            } else {
                    return true;
            }
        }
    }


    $('.sym-slides').slick({
        accessibility: false
    });
    $('.brand_slides').slick({
        fade:true, 
        arrows:false, 
        dots:true, 
        appendDots: ".brand_dots",
        accessibility: getAccessibility(),
    })


    $('.timeline_content').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: true,
        infinite: false,
        asNavFor: '.timeline_dates',
    });
    $('.timeline_dates').slick({
		slidesToShow: 5,
		slidesToScroll: 1,
        infinite: false,
        asNavFor: '.timeline_content',
        focusOnSelect: true,
        responsive: [{
            breakpoint: 600,
            settings: {
                slidesToShow: 2
            }
        }]
        
    });

    $('.properties_slick').slick({
		slidesToShow: 5,
        arrows:true,        
        autoPlay:true,
    });
    

    $(".properties-filter_selection select").on('change', function () {
        let tag = $(this).val();
        let currentIndex = 0;

        if (tag == 'view-all') {
            $('.properties_item').fadeIn();
        } else {
            $('.properties_item').fadeOut();

            $('.properties_item').each(function(idx, e){
                if ($(this).hasClass(tag)) {
                    $(this).fadeIn();
                }
            });

            $('.map_item').each(function(){
                if ($(this).hasClass(tag)) {
                    currentIndex = $(this).index();
                }
            });

            $('.map_items').slick('slickGoTo', parseInt(currentIndex));
        }
    });

})();